import { signInActionTypes } from './constants';

export function loginRequest(email_or_username: string, password: string, path: string) {
	return {
		type: signInActionTypes.LOGIN_REQUEST,
		payload: {
			email_or_username,
			password,
			path,
		},
	};
}

export function loginSuccess(token: string) {
	return {
		type: signInActionTypes.LOGIN_SUCCESS,
		payload: {
			token,
		},
	};
}

export function loginError() {
	return {
		type: signInActionTypes.LOGIN_ERROR,
	};
}
